import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { _ } from 'underscore';
import { AddComponent } from '../../questionarie-signup/questionnaire-residential/add-component';
import { questions } from '../../../assets/commercial-questionnaire';
import { Cq1Component } from './commercial-questionnaire/cq1/cq1.component';
import { Cq2Component } from './commercial-questionnaire/cq2/cq2.component';
import { Cq3Component } from './commercial-questionnaire/cq3/cq3.component';
import { Cq4Component } from './commercial-questionnaire/cq4/cq4.component';
import { Cq5Component } from './commercial-questionnaire/cq5/cq5.component';
import { Cq6Component } from './commercial-questionnaire/cq6/cq6.component';
import { CommercialService } from './commercial.service';
import { Cq7Component } from './commercial-questionnaire/cq7/cq7.component';
import { Cq8Component } from './commercial-questionnaire/cq8/cq8.component';
import { Cq9Component } from './commercial-questionnaire/cq9/cq9.component';
import { Cq10Component } from './commercial-questionnaire/cq10/cq10.component';
import { Cq11Component } from './commercial-questionnaire/cq11/cq11.component';
import { Cq12Component } from './commercial-questionnaire/cq12/cq12.component';
import { Cq13Component } from './commercial-questionnaire/cq13/cq13.component';
import { Cq14Component } from './commercial-questionnaire/cq14/cq14.component';
import { Cq15Component } from './commercial-questionnaire/cq15/cq15.component';
import { Cq17Component } from './commercial-questionnaire/cq17/cq17.component';
import { Cq16Component } from './commercial-questionnaire/cq16/cq16.component';
import { Cq18Component } from './commercial-questionnaire/cq18/cq18.component';
import { Cq19Component } from './commercial-questionnaire/cq19/cq19.component';
import { Cq20Component } from './commercial-questionnaire/cq20/cq20.component';
import { Cq21Component } from './commercial-questionnaire/cq21/cq21.component';
import { Cq22Component } from './commercial-questionnaire/cq22/cq22.component';
import { Cq23Component } from './commercial-questionnaire/cq23/cq23.component';
import { Cq24Component } from './commercial-questionnaire/cq24/cq24.component';

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.css']
})
export class QuestionnaireComponent implements OnInit {

  components = [Cq1Component, Cq2Component, Cq3Component, Cq4Component, Cq5Component, Cq6Component, Cq7Component, Cq8Component,
    Cq9Component, Cq10Component, Cq11Component, Cq12Component, Cq13Component, Cq14Component, Cq15Component, Cq16Component, Cq17Component,
  Cq18Component, Cq19Component, Cq20Component, Cq21Component, Cq22Component, Cq23Component, Cq24Component];
  comQues: AddComponent[] = [];
  questions: AddComponent[] = [];

  constructor(private commercialService: CommercialService) {
    this.commercialService.deviceWidth = window.innerWidth;
  }

  ngOnInit() {
    this.commercialService.setQuestions(questions);
    for ( let i = 0; i < questions.length; i++) {
      this.comQues.push(new AddComponent(this.components[i], questions[i]._id));
    }
    this.questions = this.comQues;
  }

}
